import { buildProps } from '@vuesax-plus/utils'

import type { ExtractPropTypes } from 'vue'
import type Plus from './plus.vue'

export const plusProps = buildProps({
  less: {
    type: Boolean,
  },
})

export type PlusProps = ExtractPropTypes<typeof plusProps>
export type PlusInstance = InstanceType<typeof Plus>
